module.exports = __webpack_public_path__ + "img/3.e5b13da1.png";